export interface EmailSummaryPayload {
  chrome_id: chromeId;
  body: string;
}
